import { FormControl, FormLabel, styled } from "@mui/material";

export const BlockWithLabelRoot = styled(FormControl)(({ theme }) => ({
	border: "1px solid rgba(0, 0, 0, 0.12)",
	borderColor: theme.palette.divider,
	borderRadius: "4px",
	padding: "12px",
	width: "100%",
	overflowY: "visible",
}));
export const BlockLabel = styled(FormLabel)(() => ({ fontSize: "10px", padding: "0 3px", height: "0px", transform: "translate(0, -9px)" }));
